import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilFinanceiro } from '../../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro das campanhas */
export const acessosCampanha: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilFinanceiro];

/** Acessos permitidos ao cadastro das campanhas na empresa Rafitec/Propex */
export const acessosCampanhaRafitecPropex: UsuarioPerfil[] = [usuarioPerfilAdministrador];

/** Retornar os acessos permitidos para as campanhas */
export function getAcessosCampanhas(authService: AuthService): UsuarioPerfil[] {
    // Rafitec
    if (authService.isRafitec() || authService.isPropex()) {
        return acessosCampanhaRafitecPropex;
    }
    return acessosCampanha;
}

@Injectable()
export class CanActivateCampanha implements CanActivateChild {

    constructor(private authGuard: AuthGuard,
                private authService: AuthService) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(getAcessosCampanhas(this.authService));
    }
}
